import { useRef, useState } from 'react';
import { captureException } from '@sentry/react';
import { Button } from 'antd';
import { TbCreditCard } from 'react-icons/tb';
import { useLocation } from 'react-router-dom';

import { createBillingPortalSession } from '@/queries/tanstack/database/aliases/billingPortal';
import { toast } from '@/shared/components/toasts/PlatformToast';
import { getInternalPathFromLocation, sanitizeRedirect } from '@/utilities';

/** Plan choices and confirmation remain inside the account's eligible Stripe portal. */
export default function BillingPlanActions() {
    const location = useLocation();
    const [busy, setBusy] = useState(false);
    const inFlight = useRef(false);
    const openPortal = async () => {
        if (inFlight.current) {
            return;
        }
        inFlight.current = true;
        setBusy(true);
        try {
            const redirect = sanitizeRedirect(
                getInternalPathFromLocation(location, { stripRedirect: true, stripStripeStatus: true }),
            );
            window.location.assign(await createBillingPortalSession(redirect));
        } catch (error) {
            captureException(error, { tags: { operation: 'billing.portal.open' } });
            toast.error('Unable to Open Billing', { description: 'Please try again. No plan changes were made here.' });
        } finally {
            inFlight.current = false;
            setBusy(false);
        }
    };
    return (
        <Button
            type='dashed'
            block
            disabled={busy}
            loading={busy}
            onClick={() => void openPortal()}
            icon={<TbCreditCard />}
            iconPosition='end'
        >
            Manage Billing
        </Button>
    );
}
